'use client';

import { c as _c } from "react/compiler-runtime";
import type { ActivityPageFieldsFragment } from '@funkey/types/graphql/graphql';
import { usePortalCtx } from '~/features/global/portal';
import QuotationCard from './QuotationCard';
import SlideUpWithButton from './SlideUpWithButton';
import { useI18n } from '~/features/i18n';
import { Auth } from '~/modules/auth/client';
export const ActivityPageQuotationCard: React.FC<{
  activity: ActivityPageFieldsFragment;
  children?: React.ReactNode;
}> = props => {
  const $ = _c(37);
  const auth = Auth.useSession();
  const portal = usePortalCtx();
  const i18n = useI18n();
  if (portal.portal === "BIZZ" && !auth.user && portal.bizz.publicPages !== "ALLOW_BOOKING") {
    return null;
  }
  const t0 = props.activity.media?.header?.path ?? null;
  let t1;
  if ($[0] !== props.activity.activityAddresses || $[1] !== props.activity.activityLanguages || $[2] !== props.activity.activityVariants || $[3] !== props.activity.hasCustomLocations || $[4] !== props.activity.hasFixedLocations || $[5] !== props.activity.hasOwnLocations || $[6] !== props.activity.id || $[7] !== props.activity.name || $[8] !== props.activity.slug || $[9] !== props.activity.transportCosts || $[10] !== props.activity.transportMultiplier || $[11] !== t0) {
    t1 = <QuotationCard activity={{
      id: props.activity.id,
      name: props.activity.name,
      slug: props.activity.slug,
      imagePath: t0,
      activityVariants: props.activity.activityVariants,
      activityLanguages: props.activity.activityLanguages,
      activityAddresses: props.activity.activityAddresses,
      transportMultiplier: props.activity.transportMultiplier,
      transportCosts: props.activity.transportCosts,
      hasOwnLocations: props.activity.hasOwnLocations,
      hasFixedLocations: props.activity.hasFixedLocations,
      hasCustomLocations: props.activity.hasCustomLocations
    }} className="mb-5 mt-15 self-start rounded-2xl bg-white p-10 lg:mt-0" />;
    $[0] = props.activity.activityAddresses;
    $[1] = props.activity.activityLanguages;
    $[2] = props.activity.activityVariants;
    $[3] = props.activity.hasCustomLocations;
    $[4] = props.activity.hasFixedLocations;
    $[5] = props.activity.hasOwnLocations;
    $[6] = props.activity.id;
    $[7] = props.activity.name;
    $[8] = props.activity.slug;
    $[9] = props.activity.transportCosts;
    $[10] = props.activity.transportMultiplier;
    $[11] = t0;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== props.children || $[14] !== t1) {
    t2 = <aside className="sticky top-32 hidden sm:min-w-[400px] md:block lg:w-100">{t1}{props.children}</aside>;
    $[13] = props.children;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== i18n) {
    t3 = i18n._("pdp.mobile.add-to-quotation.cta");
    $[16] = i18n;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const t4 = props.activity.media?.header?.path ?? null;
  let t5;
  if ($[18] !== props.activity.activityAddresses || $[19] !== props.activity.activityLanguages || $[20] !== props.activity.activityVariants || $[21] !== props.activity.hasCustomLocations || $[22] !== props.activity.hasFixedLocations || $[23] !== props.activity.hasOwnLocations || $[24] !== props.activity.id || $[25] !== props.activity.name || $[26] !== props.activity.slug || $[27] !== props.activity.transportCosts || $[28] !== props.activity.transportMultiplier || $[29] !== t4) {
    t5 = <QuotationCard activity={{
      id: props.activity.id,
      name: props.activity.name,
      slug: props.activity.slug,
      imagePath: t4,
      activityVariants: props.activity.activityVariants,
      activityLanguages: props.activity.activityLanguages,
      activityAddresses: props.activity.activityAddresses,
      transportMultiplier: props.activity.transportMultiplier,
      transportCosts: props.activity.transportCosts,
      hasOwnLocations: props.activity.hasOwnLocations,
      hasFixedLocations: props.activity.hasFixedLocations,
      hasCustomLocations: props.activity.hasCustomLocations
    }} className="bg-white p-10 lg:mt-0" />;
    $[18] = props.activity.activityAddresses;
    $[19] = props.activity.activityLanguages;
    $[20] = props.activity.activityVariants;
    $[21] = props.activity.hasCustomLocations;
    $[22] = props.activity.hasFixedLocations;
    $[23] = props.activity.hasOwnLocations;
    $[24] = props.activity.id;
    $[25] = props.activity.name;
    $[26] = props.activity.slug;
    $[27] = props.activity.transportCosts;
    $[28] = props.activity.transportMultiplier;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== t3 || $[32] !== t5) {
    t6 = <SlideUpWithButton iconBefore="plus" label={t3} className="isolate z-20 sm:hidden">{t5}</SlideUpWithButton>;
    $[31] = t3;
    $[32] = t5;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== t2 || $[35] !== t6) {
    t7 = <div className="relative lg:shrink-0">{t2}{t6}</div>;
    $[34] = t2;
    $[35] = t6;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  return t7;
};